import React from 'react';
import { Typography, Card, Row, Col, Timeline, Button, Space } from 'antd';
import { 
  CheckCircleOutlined,
  StarOutlined,
  TeamOutlined,
  MobileOutlined,
  GlobalOutlined,
  CloudOutlined,
  SecurityScanOutlined,
  SyncOutlined,
  CrownOutlined,
  GiftOutlined
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

const About = () => {
  const features = [
    {
      icon: <MobileOutlined />,
      title: '多平台支持',
      desc: 'Web端、移动APP、微信小程序全覆盖'
    },
    {
      icon: <CloudOutlined />,
      title: '云端同步',
      desc: '数据实时同步，多设备无缝切换'
    },
    {
      icon: <SecurityScanOutlined />,
      title: '安全可靠',
      desc: '数据加密传输，隐私信息保护'
    },
    {
      icon: <SyncOutlined />,
      title: '实时更新',
      desc: '功能持续优化，体验不断提升'
    }
  ];

  const milestones = [
    {
      time: '2025年10月',
      title: '管理师软件V1.0发布',
      desc: '核心功能模块上线，支持20个管理领域'
    },
    {
      time: '2025年10月',
      title: '微信小程序上线',
      desc: '小程序版本发布，支持微信登录和支付'
    },
    {
      time: '2025年10月',
      title: '移动APP开发完成',
      desc: 'Android/iOS原生应用开发完成'
    },
    {
      time: '2025年10月',
      title: '推荐分享系统上线',
      desc: '一键分享功能，积分奖励机制'
    }
  ];

  return (
    <div style={{ maxWidth: 1200, margin: '20px auto', padding: '0 16px' }}>
      {/* 公司介绍 */}
      <div style={{ textAlign: 'center', marginBottom: '50px' }}>
        <Title level={1}>关于管理师</Title>
        <Paragraph style={{ fontSize: '18px', color: '#666', maxWidth: '800px', margin: '0 auto' }}>
          管理师是一款专业的个人和团队管理系统，致力于帮助用户高效管理生活和工作的各个方面。
          我们相信，通过科学的管理方法和现代化的技术手段，每个人都能成为自己生活的管理师。
        </Paragraph>
      </div>

      {/* 产品特色 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <StarOutlined style={{ marginRight: '8px', color: '#1890ff' }} />
          产品特色
        </Title>
        <Row gutter={[24, 24]}>
          {features.map((feature, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <div style={{ textAlign: 'center' }}>
                <div style={{ 
                  fontSize: '32px', 
                  color: '#1890ff', 
                  marginBottom: '12px' 
                }}>
                  {feature.icon}
                </div>
                <Title level={5}>{feature.title}</Title>
                <Text style={{ color: '#666' }}>{feature.desc}</Text>
              </div>
            </Col>
          ))}
        </Row>
      </Card>

      {/* 核心功能 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <CheckCircleOutlined style={{ marginRight: '8px', color: '#52c41a' }} />
          核心功能
        </Title>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Title level={4}>📁 文件管理</Title>
            <Paragraph>
              智能分类存储文档资料，支持快速检索和标签管理，让您的文件井然有序。
            </Paragraph>
          </Col>
          <Col xs={24} md={12}>
            <Title level={4}>💰 资金管理</Title>
            <Paragraph>
              记录收支明细，生成财务报表，帮您掌握财务状况，实现理财目标。
            </Paragraph>
          </Col>
          <Col xs={24} md={12}>
            <Title level={4}>⏰ 时间管理</Title>
            <Paragraph>
              日程安排、任务提醒、时间统计，让您的时间管理更加科学高效。
            </Paragraph>
          </Col>
          <Col xs={24} md={12}>
            <Title level={4}>👥 团队协作</Title>
            <Paragraph>
              项目管理、任务分配、进度跟踪，提升团队协作效率。
            </Paragraph>
          </Col>
        </Row>
      </Card>

      {/* 发展历程 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <TeamOutlined style={{ marginRight: '8px', color: '#722ed1' }} />
          发展历程
        </Title>
        <Timeline>
          {milestones.map((milestone, index) => (
            <Timeline.Item 
              key={index}
              dot={<CheckCircleOutlined style={{ color: '#52c41a' }} />}
            >
              <Title level={5}>{milestone.title}</Title>
              <Text style={{ color: '#666' }}>{milestone.time}</Text>
              <br />
              <Text>{milestone.desc}</Text>
            </Timeline.Item>
          ))}
        </Timeline>
      </Card>

      {/* 会员体系 */}
      <Card style={{ marginBottom: '40px' }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          <CrownOutlined style={{ marginRight: '8px', color: '#fa8c16' }} />
          会员体系
        </Title>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={8}>
            <Card style={{ textAlign: 'center', height: '200px' }}>
              <Title level={4}>普通会员</Title>
              <Text style={{ fontSize: '24px', color: '#1890ff', fontWeight: 'bold' }}>
                免费
              </Text>
              <br />
              <br />
              <Text>基础功能使用</Text>
              <br />
              <Text>文件管理</Text>
              <br />
              <Text>物品管理</Text>
              <br />
              <Text>资金管理</Text>
              <br />
              <Text>时间管理</Text>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card style={{ textAlign: 'center', height: '200px', border: '2px solid #52c41a' }}>
              <Title level={4}>高级会员</Title>
              <Text style={{ fontSize: '24px', color: '#52c41a', fontWeight: 'bold' }}>
                98元/年
              </Text>
              <br />
              <br />
              <Text>解锁全部20个模块</Text>
              <br />
              <Text>云端数据同步</Text>
              <br />
              <Text>高级功能使用</Text>
              <br />
              <Text>优先客服支持</Text>
              <br />
              <Text>数据备份服务</Text>
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card style={{ textAlign: 'center', height: '200px' }}>
              <Title level={4}>VIP会员</Title>
              <Text style={{ fontSize: '24px', color: '#fa8c16', fontWeight: 'bold' }}>
                198元/年
              </Text>
              <br />
              <br />
              <Text>所有功能无限制</Text>
              <br />
              <Text>专属客服支持</Text>
              <br />
              <Text>定制化服务</Text>
              <br />
              <Text>API接口访问</Text>
              <br />
              <Text>企业级功能</Text>
            </Card>
          </Col>
        </Row>
      </Card>

      {/* 推荐奖励 */}
      <Card style={{ marginBottom: '40px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div style={{ textAlign: 'center', color: 'white' }}>
          <GiftOutlined style={{ fontSize: '48px', marginBottom: '16px' }} />
          <Title level={3} style={{ color: 'white', marginBottom: '16px' }}>
            推荐奖励计划
          </Title>
          <Paragraph style={{ color: 'white', fontSize: '16px', marginBottom: '20px' }}>
            邀请好友注册使用管理师，获得积分奖励
          </Paragraph>
          <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
            <Col xs={24} sm={8}>
              <Text style={{ color: 'white', fontSize: '18px' }}>
                推荐注册：+1积分
              </Text>
            </Col>
            <Col xs={24} sm={8}>
              <Text style={{ color: 'white', fontSize: '18px' }}>
                推荐高级会员：+2积分
              </Text>
            </Col>
            <Col xs={24} sm={8}>
              <Text style={{ color: 'white', fontSize: '18px' }}>
                推荐VIP会员：+3积分
              </Text>
            </Col>
          </Row>
        </div>
      </Card>

      {/* 联系我们 */}
      <Card>
        <Title level={3} style={{ textAlign: 'center', marginBottom: '30px' }}>
          联系我们
        </Title>
        <Row gutter={[24, 24]}>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center' }}>
              <GlobalOutlined style={{ fontSize: '32px', color: '#1890ff', marginBottom: '12px' }} />
              <Title level={5}>官方网站</Title>
              <Text>https://manage.net.cn</Text>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center' }}>
              <MobileOutlined style={{ fontSize: '32px', color: '#52c41a', marginBottom: '12px' }} />
              <Title level={5}>技术支持</Title>
              <Text>通过应用内"个人中心"联系</Text>
            </div>
          </Col>
          <Col xs={24} md={8}>
            <div style={{ textAlign: 'center' }}>
              <CheckCircleOutlined style={{ fontSize: '32px', color: '#fa8c16', marginBottom: '12px' }} />
              <Title level={5}>ICP备案</Title>
              <Text>闽ICP备2025109602号-6</Text>
            </div>
          </Col>
        </Row>
      </Card>

      {/* 版权信息 */}
      <div style={{ textAlign: 'center', marginTop: '40px', padding: '20px', background: '#f5f5f5', borderRadius: '8px' }}>
        <Text style={{ color: '#999' }}>
          © 2025 管理师软件 版权所有 | 
          <a href="/terms" style={{ margin: '0 8px' }}>用户协议</a> | 
          <a href="/privacy" style={{ margin: '0 8px' }}>隐私政策</a> | 
          <a href="/billing" style={{ margin: '0 8px' }}>付费条款</a>
        </Text>
      </div>
    </div>
  );
};

export default About;
